<kendo-buttongroup
  class="segmented-field"
  selection="single"
  [disabled]="!!props.disabled">
  <button
    kendoButton
    type="button"
    *ngFor="let option of segments; let i = index"
    [id]="id + '_' + i"
    [toggleable]="true"
    [selected]="isSelected(option)"
    [attr.aria-label]="option.label"
    (click)="select(option)">
    {{ option.label }}
  </button>
</kendo-buttongroup>
